import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateStruct, NgbDateParserFormatter  } from '@ng-bootstrap/ng-bootstrap';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams, IDoesFilterPassParams, IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
  selector: 'app-updated-filter',
  templateUrl: './updated-filter.component.html',
  styleUrls: ['./updated-filter.component.scss']
})
export class UpdatedFilterComponent implements IFilterAngularComp, AfterViewInit {
  
  params: IFilterParams;

  guiParams: any;
  
  filterText = '';

  destroySubscription = false;

  hoveredDate = null;

	fromDate: any;
	
  toDate: any = null;
  
  @ViewChild('datepicker') datepicker: any;

  constructor(public calendar: NgbCalendar, public formatter: NgbDateParserFormatter) {
		this.fromDate = calendar.getToday();
		this.toDate = calendar.getNext(calendar.getToday(), 'd', 1);
	}

  agInit(params: IFilterParams): void {
    this.params = params;
  }

  isFilterActive(): boolean {
    return this.fromDate != null && this.toDate != null // this.filterText != null && this.filterText !== '';
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    let passed = true;
    const { node } = params;
    // const val = this.filterText.toLowerCase();
    if(!this.fromDate && !this.toDate) {
      passed = false;
    }

    return passed;
  }

  getModel() {
      if (!this.isFilterActive()) {
          return null;
      }

      return { value: {
        from: this.fromDate,
        to: this.toDate
      } };
  }

  setModel(model: any) {
      this.fromDate = model == null ? null : model.value.from;
      this.toDate = model == null ? null : model.value.to;
  }


  ngAfterViewInit() {
    this.datepicker.open();
  }

  onDateSelection(date: NgbDate) {
		if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
		} else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
			this.toDate = date;
		} else {
			this.toDate = null;
			this.fromDate = date;
		}
    if(this.fromDate && this.toDate) {
      this.params.filterChangedCallback();
      this.guiParams.hidePopup();
    }
	}

	isHovered(date: NgbDate) {
		return (
			this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
		);
	}

	isInside(date: NgbDate) {
		return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
	}

	isRange(date: NgbDate) {
		return (
			date.equals(this.fromDate) ||
			(this.toDate && date.equals(this.toDate)) ||
			this.isInside(date) ||
			this.isHovered(date)
		);
	}

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
		const parsed = this.formatter.parse(input);
		return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
	}

  abcd(fromDate: any, dpFromDate: any) {
    this.fromDate = this.validateInput(fromDate, dpFromDate)
  }

  xyz(toDate: any, dpToDate: any) {
    this.toDate = this.validateInput(toDate, dpToDate.value)
  }


  destroy() {
    this.destroySubscription = true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams) {
      this.guiParams = params;
  }

  clearDp() {
    this.fromDate = null;
    this.toDate = null;
    this.params.filterChangedCallback();
  }

}
